import { render } from "./NoDataOverlay.vue?vue&type=template&id=50b1554d&scoped=true"
import script from "./NoDataOverlay.vue?vue&type=script&lang=js"
export * from "./NoDataOverlay.vue?vue&type=script&lang=js"

import "./NoDataOverlay.vue?vue&type=style&index=0&id=50b1554d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b1554d"]])

export default __exports__